import { IDichVuThongTin } from "../../model/respone/dich-vu/IDichVuThongTin";
import { apiClient } from "../apiClient";

export const DICH_VU_THONG_TIN_ENDPOINT = "dich-vu-thong-tin";
export const dichVuThongTinApi = {
  SelectAll: () => apiClient.get(`${DICH_VU_THONG_TIN_ENDPOINT}`),
  Insert: (payload: IDichVuThongTin) =>
    apiClient.post(`${DICH_VU_THONG_TIN_ENDPOINT}`, payload),
  Update: (payload: IDichVuThongTin) =>
    apiClient.put(`${DICH_VU_THONG_TIN_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${DICH_VU_THONG_TIN_ENDPOINT}/${id}`),
};
